(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('MVMNTUserService', MVMNTUserService)
	MVMNTUserService.$inject = ['$http']
	function MVMNTUserService($http){
		return {
			getAllUsersByParent: getAllUsersByParent,
			getAllUsersByProperty: getAllUsersByProperty,
			getAllUsers: getAllUsers,
			getAllUserSimples: getAllUserSimples,
			getUsersLookup: getUsersLookup,
			getSearchUsers: getSearchUsers,
			getUser: getUser,
			addUser: addUser,
			reinviteUser: reinviteUser,
			updateUser: updateUser,
			updateUserRegister: updateUserRegister,
			updatePermissions: updatePermissions,
			attachRole: attachRole,
			detachRole: detachRole,
			attachUserToParent: attachUserToParent,
			detachUserFromParent: detachUserFromParent,
			deleteUser: deleteUser,
			getUnassociatedUsersByParent: getUnassociatedUsersByParent,
			getAllUsersByRole: getAllUsersByRole
		}
		function getAllUsersByParent(parentId,parentType){
			return $http.get('/mvmnt-api/users-by-parent/' + parentId + '/' + parentType)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAllUsersByProperty(property1Name,property1Value){
			return $http.get('/mvmnt-api/all-users-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAllUsers(){
			return $http.get('/mvmnt-api/all-users')
			.then(function(response){
				return {
					data: response.data.payload,
					count: response.data.count
				};
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAllUserSimples(){
			return $http.get('/mvmnt-api/all-user-simples')
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getUsersLookup(){
			return $http.get('/mvmnt-api/users-lookup')
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getSearchUsers(){
			return $http.get('/mvmnt-api/search-users/' + parentId)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getUser(userId){
			return $http.get('/mvmnt-api/user/' + userId)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function addUser(data){
			return $http.post('/mvmnt-api/user', data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function reinviteUser(userId){
			return $http.post('/mvmnt-api/reinvite-user/' + userId)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function updateUser(userId, data){
			return $http.put('/mvmnt-api/user/' + userId, data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function updateUserRegister(userId, data){
			return $http.put('/mvmnt-api/register/' + userId, data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function updatePermissions(data){
			return $http.post('/user-permission', data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function attachRole(data){
			return $http.post('/mvmnt-api/user-attach-role', data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function detachRole(data){
			return $http.post('/mvmnt-api/user-detach-role', data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function attachUserToParent(data){
			return $http.post('/mvmnt-api/attach-user-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function detachUserFromParent(data){
			return $http.post('/mvmnt-api/detach-user-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function deleteUser(userId, data){
			return $http.delete('/mvmnt-api/user/' + userId)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getUnassociatedUsersByParent(parentId,parentType){
			return $http.get('/mvmnt-api/unassociated-users-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAllUsersByRole(roleName){
            return $http.get('/mvmnt-api/all-users-by-role/' + roleName )
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('AddressService', AddressService)
	AddressService.$inject = ['$http']
	function AddressService($http){
		return {
			getAllAddressesByParent: getAllAddressesByParent,
			getAllAddressesByProperty: getAllAddressesByProperty,
			getAllAddresses: getAllAddresses,
			getSearchAddresses: getSearchAddresses,
			getAddress: getAddress,
			parseAddress: parseAddress,
			addAddress: addAddress,
			updateAddress: updateAddress,
			deleteAddress: deleteAddress
		}
		function getAllAddressesByParent(parentId,parentType){
			return $http.get('/mvmnt-api/addresses-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}

			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAllAddressesByProperty(property1Name,property1Value){
			return $http.get('/mvmnt-api/all-addresses-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAllAddresses(){
			return $http.get('/mvmnt-api/all-addresses')
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getSearchAddresses(){
			return $http.get('/mvmnt-api/search-addresses/' + parentId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAddress(addressId){
			return $http.get('/mvmnt-api/address/' + addressId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function parseAddress(data){
			return $http.post('/mvmnt-api/address/parse', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function addAddress(data){
			return $http.post('/mvmnt-api/address', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function updateAddress(addressId, data){
			return $http.put('/mvmnt-api/address/' + addressId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function deleteAddress(addressId){
			return $http.delete('/mvmnt-api/address/' + addressId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('AlertService', AlertService)
	AlertService.$inject = ['$http']
	function AlertService($http){
		return {
			getAllAlertsByParent: getAllAlertsByParent,
			getAllAlertsByProperty: getAllAlertsByProperty,
			getAllAlerts: getAllAlerts,
			getSearchAlerts: getSearchAlerts,
			getAlert: getAlert,
			addAlert: addAlert,
			updateAlert: updateAlert,
			deleteAlert: deleteAlert
		}
		function getAllAlertsByParent(parentId,parentType){
			return $http.get('/mvmnt-api/alerts-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllAlertsByProperty(property1Name,property1Value){
			return $http.get('/mvmnt-api/all-alerts-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllAlerts(){
			return $http.get('/mvmnt-api/all-alerts')
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getSearchAlerts(){
			return $http.get('/mvmnt-api/search-alerts/' + parentId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAlert(alertsId){
			return $http.get('/mvmnt-api/alerts/' + alertsId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function addAlert(data){
			return $http.post('/mvmnt-api/alert', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function updateAlert(alertsId, data){
			return $http.put('/mvmnt-api/alert/' + alertsId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function deleteAlert(alertsId, data){
			return $http.delete('/mvmnt-api/alert/' + alertsId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};

	} 
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('ApprovalService', ApprovalService)
	ApprovalService.$inject = ['$http']
	function ApprovalService($http){
		return {
			getAllApprovalsByParent: getAllApprovalsByParent,
			getAllApprovalsByProperty: getAllApprovalsByProperty,
			getAllApprovals: getAllApprovals,
			getSearchApprovals: getSearchApprovals,
			getApproval: getApproval,
			addApproval: addApproval,
			requestApproval: requestApproval,
			updateApproval: updateApproval,
			updateApprovalApprove: updateApprovalApprove,
			updateApprovalDeny: updateApprovalDeny,
			deleteApproval: deleteApproval
		}
		function getAllApprovalsByParent(parentId,parentType){
			return $http.get('/mvmnt-api/approvals-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};

		function getAllApprovalsByProperty(propertyName, propertyValue){
			return $http.get('/mvmnt-api/all-approvals-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};

		function getAllApprovals(){
			return $http.get('/mvmnt-api/all-approvals')
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};

		function getSearchApprovals(){
			return $http.get('/mvmnt-api/search-approvals/' + parentId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};

		function getApproval(approvalId){
			return $http.get('/mvmnt-api/approval/' + approvalId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};

		function addApproval(data){
			return $http.post('/mvmnt-api/approval', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};

		function requestApproval(data){
			return $http.post('/mvmnt-api/request-approval', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function updateApproval(approvalId, data){
			return $http.put('/mvmnt-api/approval/' + approvalId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};

		function updateApprovalApprove(approvalId, data){
			return $http.put('/mvmnt-api/approval/' + approvalId + '/approve', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};

		function updateApprovalDeny(approvalId, data){
			return $http.put('/mvmnt-api/approval/' + approvalId + '/deny', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};

		function deleteApproval(approvalId, data){
			return $http.delete('/mvmnt-api/approval/' + approvalId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
	} 
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('AttachmentService', AttachmentService)
	AttachmentService.$inject = ['$http']
	function AttachmentService($http){
		return {
			getAllAttachmentsByParent: getAllAttachmentsByParent,
			getAllAttachmentsByProperty: getAllAttachmentsByProperty,
			getAllAttachments: getAllAttachments,
			getAllMediaByParent: getAllMediaByParent,
			getSearchAttachments: getSearchAttachments,
			getAttachment: getAttachment,
			addAttachment: addAttachment,
			updateAttachment: updateAttachment,
			preferAttachment: preferAttachment,
			deleteAttachment: deleteAttachment
		}
		function getAllAttachmentsByParent(parentId,parentType){
			return $http.get('/mvmnt-api/attachments-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAllMediaByParent(parentId,parentType){
			return $http.get('/mvmnt-api/attachment-media-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAllAttachmentsByProperty(property1Name,property1Value){
			return $http.get('/mvmnt-api/all-attachments-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAllAttachments(){
			return $http.get('/mvmnt-api/all-attachments')
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getSearchAttachments(){
			return $http.get('/mvmnt-api/search-attachments/' + parentId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAttachment(attachmentId){
			return $http.get('/mvmnt-api/attachment/' + attachmentId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function addAttachment(data){
			return $http.post('/mvmnt-api/attachment', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function updateAttachment(attachmentId, data){
			return $http.put('/mvmnt-api/attachment/' + attachmentId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function preferAttachment(attachmentId, data){
			return $http.put('/mvmnt-api/attachment/' + attachmentId + '/prefer', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function deleteAttachment(attachmentId, data){
			return $http.delete('/mvmnt-api/attachment/' + attachmentId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('BaseService', BaseService)
	BaseService.$inject = ['$http']
	function BaseService($http){
	}
});
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('CartService', CartService)
	CartService.$inject = ['$http']
	function CartService($http){
		var service = {
			getCart:getCart,
			getCartCount:getCartCount,
			addCartItem:addCartItem,
			updateCartItem:updateCartItem,
			deleteCartItem:deleteCartItem
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/

		function getCart(){
			return $http.get('/api/cart')
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getCartCount(){
			return $http.get('/api/cart-item-count')
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addCartItem(data){
			return $http.post('/api/cart-item', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updateCartItem(itemId, data){
			return $http.put('/api/cart-item/' + itemId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function deleteCartItem(itemId){
			return $http.delete('/api/cart-item/' + itemId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('CategoryService', CategoryService)
	CategoryService.$inject = ['$http']
	function CategoryService($http){
		return {
			getAllCategoriesByParent: getAllCategoriesByParent,
			getAllCategoriesByProperty: getAllCategoriesByProperty,
			getAllCategories: getAllCategories,
			getCategory: getCategory,
			addCategory: addCategory,
			updateCategory: updateCategory,
			deleteCategory: deleteCategory,
		}
		function getAllCategoriesByParent(parentId,parentType){
			return $http.get('/mvmnt-api/categories-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllCategoriesByProperty(property1Name,property1Value){
			return $http.get('/mvmnt-api/all-categories-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllCategories(q){
			return $http.get('/mvmnt-api/all-categories/' + q)
			.then(function(response){
				
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getCategory(categoryId){
			return $http.get('/mvmnt-api/category/' + categoryId)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function addCategory(data){
			return $http.post('/mvmnt-api/category', data)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function updateCategory(categoryId, data){
			return $http.put('/mvmnt-api/category/' + categoryId, data)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function deleteCategory(categoryId, data){
			return $http.delete('/mvmnt-api/category/' + categoryId)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
	} 
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('ChangeService', ChangeService)
	ChangeService.$inject = ['$http']
	function ChangeService($http){
		return {
			getAllChangesByParent: getAllChangesByParent,
			getAllChangesByProperty: getAllChangesByProperty,
			getAllChanges: getAllChanges,
			getSearchChanges: getSearchChanges,
			getChange: getChange,
			addChange: addChange,
			updateChange: updateChange,
			deleteChange: deleteChange
		}
		function getAllChangesByParent(parentId,parentType){
			
			return $http.get('/mvmnt-api/changes-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllChangesByProperty(property1Name,property1Value){
			return $http.get('/mvmnt-api/all-changes-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllChanges(){
			return $http.get('/mvmnt-api/all-changes')
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getSearchChanges(){
			return $http.get('/mvmnt-api/search-changes/' + parentId)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getChange(changeId){
			return $http.get('/mvmnt-api/change/' + changeId)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function addChange(data){
			return $http.post('/mvmnt-api/change', data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function updateChange(changeId, data){
			return $http.put('/mvmnt-api/change/' + changeId, data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function deleteChange(changeId, data){
			return $http.delete('/mvmnt-api/change/' + changeId)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
	} 
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('CheckoutService', CheckoutService)
	CheckoutService.$inject = ['$http']
	function CheckoutService($http){
		var service = {
			getCart:getCart
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/

		function getCart(){
			return $http.get('/api/cart')
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getCartCount(){
			return $http.get('/api/cart-item-count')
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addCartItem(data){
			return $http.post('/api/cart-item', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updateCartItem(itemId, data){
			return $http.put('/api/cart-item/' + itemId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function deleteCartItem(itemId){
			return $http.delete('/api/cart-item/' + itemId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('ComponentService', ComponentService)
	ComponentService.$inject = ['$http']
	function ComponentService($http){
		return {
			getAllComponentsByParent: getAllComponentsByParent,
			getSessionComponents: getSessionComponents,
			getAllComponentsByProperty: getAllComponentsByProperty,
			getAllComponents: getAllComponents,
			getSearchComponents: getSearchComponents,
			getComponent: getComponent,
			addComponent: addComponent,
			updateComponent: updateComponent,
			attachRole: attachRole,
			detachRole: detachRole,
			deleteComponent: deleteComponent
		}
		function getAllComponentsByParent(parentId,parentType){
			return $http.get('/mvmnt-api/all-components-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getSessionComponents(){
			return $http.get('/mvmnt-api/session-components')
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllComponentsByProperty(property1Name,property1Value){
			return $http.get('/mvmnt-api/all-components-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllComponents(){
			return $http.get('/mvmnt-api/all-components')
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getSearchComponents(){
			return $http.get('/mvmnt-api/search-components/' + parentId)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getComponent(componentId){
			return $http.get('/mvmnt-api/component/' + componentId)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function addComponent(data){
			return $http.post('/mvmnt-api/component', data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function updateComponent(componentId, data){
			return $http.put('/mvmnt-api/component/' + componentId, data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function attachRole(data){
			return $http.post('/mvmnt-api/component-attach-role', data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function detachRole(data){
			return $http.post('/mvmnt-api/component-detach-role', data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function deleteComponent(componentId, data){
			return $http.delete('/mvmnt-api/component/' + componentId)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
	} 
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('EmailService', EmailService)
	EmailService.$inject = ['$http']
	function EmailService($http){
		var service = {
			getAllEmailsByParent:getAllEmailsByParent,
			getAllEmailsByProperty:getAllEmailsByProperty,
			getEmailsByScope:getEmailsByScope,
			getAllEmails:getAllEmails,
			getEmail:getEmail,
			addEmail:addEmail,
			attachEmailToParent:attachEmailToParent,
			detachEmailFromParent:detachEmailFromParent,
			updateEmail:updateEmail,
			deleteEmail:deleteEmail
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/
		function getAllEmailsByParent(parentId,parentType){
			return $http.get('/mvmnt-api/emails-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllEmailsByProperty(propertyName,propertyValue){
			return $http.get('/mvmnt-api/emails-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getEmailsByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/mvmnt-api/emails-by-scope/' + scopeName;
			if ((count != undefined) && (count != '')) {
				url = url + '/' + count;
			}
			if ((queryParam != undefined) && (queryParam != '')) {
				url = url + '/' + queryParam;
			}
			if ((queryParam1 != undefined) && (queryParam1 != '')) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getEmailsByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllEmails(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/mvmnt-api/all-emails';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getEmail(emailId){
			return $http.get('/mvmnt-api/email/' + emailId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addEmail(data){
			return $http.post('/mvmnt-api/email', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updateEmail(emailId, data){
			return $http.put('/mvmnt-api/email/' + emailId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};


		function attachEmailToParent(data){
			return $http.post('/mvmnt-api/attach-email-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachEmailFromParent(data){
			return $http.post('/mvmnt-api/detach-email-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteEmail(emailId, data){
			return $http.delete('/mvmnt-api/email/' + emailId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('FileUploadService', FileUploadService)
	FileUploadService.$inject = ['$http', '$q']
	function FileUploadService($http, $q){
		return {
			uploadFileToUrl: uploadFileToUrl
		}
		function uploadFileToUrl(file, uploadUrl, addons){
			var formData = new FormData();
			if (file instanceof FileList) {
				for (var i = 0; i < file.length; i++) {
					formData.append('file['+i+']', file[i]);
				}
			} else {
				formData.append('file', file);
			}
			if(addons != undefined){
				angular.forEach(addons, function (value, index) {
					formData.append(index, value);
				});
				formData.append('_token', addons._token);
				formData.append('parentType', addons.parentType);
				formData.append('parentId', addons.parentId);
			}
			var obj = {};
			for (var entry of formData.entries()){
				obj[entry[0]] = entry[1];
			}

			// create the headers
			var requestHeaders = {
				transformRequest: angular.identity,
				headers: {'Content-Type': undefined}
			}

			return $http.post(uploadUrl, formData, requestHeaders)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('focus', function ($timeout, $window) {
		return function (id) {
			$timeout(function () {
				var element = $window.document.getElementById(id);
				if (element)
					element.focus();
			},100);
		};
	});
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('HelpService', HelpService)
	HelpService.$inject = ['$http']
	function HelpService($http){
		var service = {
			getAllHelpsByParent:getAllHelpsByParent,
			getAllHelpsByProperty:getAllHelpsByProperty,
			getAllHelps:getAllHelps,
			getHelp:getHelp,
			addHelp:addHelp,
			attachHelpToParent:attachHelpToParent,
			detachHelpFromParent:detachHelpFromParent,
			updateHelp:updateHelp,
			deleteHelp:deleteHelp
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/

		function getAllHelpsByParent(parentId,parentType){
			return $http.get('/mvmnt-api/helps-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllHelpsByProperty(propertyName,propertyValue){
			return $http.get('/mvmnt-api/helps-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllHelps(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/mvmnt-api/all-helps';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getHelp(helpId){
			return $http.get('/mvmnt-api/help/' + helpId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addHelp(data){
			return $http.post('/mvmnt-api/help', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updateHelp(helpId, data){
			return $http.put('/mvmnt-api/help/' + helpId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};


		function attachHelpToParent(data){
			return $http.post('/mvmnt-api/attach-help-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachHelpFromParent(data){
			return $http.post('/mvmnt-api/detach-help-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteHelp(helpId, data){
			return $http.delete('/mvmnt-api/help/' + helpId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('InvoiceService', InvoiceService)
	InvoiceService.$inject = ['$http']
	function InvoiceService($http){
		return {
			getAllInvoicesByParent: getAllInvoicesByParent,
			getAllInvoicesByProperty: getAllInvoicesByProperty,
			getAllInvoices: getAllInvoices,
			getSearchInvoices: getSearchInvoices,
			getInvoice: getInvoice,
			addInvoice: addInvoice,
			updateInvoice: updateInvoice,
			deleteInvoice: deleteInvoice
		}
		function getAllInvoicesByParent(parentId,parentType){
			return $http.get('/mvmnt-api/invoices-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllInvoicesByProperty(property1Name,property1Value){
			return $http.get('/mvmnt-api/all-invoices-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllInvoices(){
			return $http.get('/mvmnt-api/all-invoices')
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getSearchInvoices(){
			return $http.get('/mvmnt-api/search-invoices/' + parentId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getInvoice(invoiceId){
			return $http.get('/mvmnt-api/invoice/' + invoiceId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function addInvoice(data){
			return $http.post('/mvmnt-api/invoice', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function updateInvoice(invoiceId, data){
			return $http.put('/mvmnt-api/invoice/' + invoiceId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function deleteInvoice(invoiceId, data){
			return $http.delete('/mvmnt-api/invoice/' + invoiceId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
	} 
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('JournalService', JournalService)
	JournalService.$inject = ['$http']
	function JournalService($http){
		return {
			getAllJournalsByParent: getAllJournalsByParent,
			getAllJournalsByProperty: getAllJournalsByProperty,
			getAllJournals: getAllJournals,
			getSearchJournals: getSearchJournals,
			getJournal: getJournal,
			addJournal: addJournal,
			updateJournal: updateJournal,
			deleteJournal: deleteJournal
		}
		function getAllJournalsByParent(parentId,parentType){
			return $http.get('/mvmnt-api/journals-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllJournalsByProperty(property1Name,property1Value){
			return $http.get('/mvmnt-api/all-journals-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllJournals(){
			return $http.get('/mvmnt-api/all-journals')
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getSearchJournals(){
			return $http.get('/mvmnt-api/search-journals/' + parentId)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getJournal(journalId){
			return $http.get('/mvmnt-api/journal/' + journalId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function addJournal(data){
			return $http.post('/mvmnt-api/journal', data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function updateJournal(journalId, data){
			return $http.put('/mvmnt-api/journal/' + journalId, data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function deleteJournal(journalId, data){
			return $http.delete('/mvmnt-api/journal/' + journalId)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
	} 
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('LinkService', LinkService)
	LinkService.$inject = ['$http']
	function LinkService($http){
		return {
			getAllLinksByParent: getAllLinksByParent,
			getSessionLinks: getSessionLinks,
			getAllLinksByProperty: getAllLinksByProperty,
			getAllLinks: getAllLinks,
			getSearchLinks: getSearchLinks,
			getLink: getLink,
			getNavMenu: getNavMenu,
			getNavigation: getNavigation,
			addLink: addLink,
			updateLink: updateLink,
			updateNavigation: updateNavigation,
			attachRole: attachRole,
			detachRole: detachRole,
			deleteLink: deleteLink
		}
		function getAllLinksByParent(parentId,parentType){
			return $http.get('/mvmnt-api/all-links-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getSessionLinks(){
			return $http.get('/mvmnt-api/session-links?' + Date.now())
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllLinksByProperty(property1Name,property1Value){
			return $http.get('/mvmnt-api/all-links-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllLinks(){
			return $http.get('/mvmnt-api/all-links',{cache: true})
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getSearchLinks(){
			return $http.get('/mvmnt-api/search-links/' + parentId)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getLink(linkId){
			return $http.get('/mvmnt-api/link/' + linkId)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getNavMenu(){
			return $http.get('/mvmnt-api/nav-menu')
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});
		};
		
		function getNavigation(){
			return $http.get('/mvmnt-api/navigation')
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});
		};
		
		function addLink(data){
			return $http.post('/mvmnt-api/link', data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function updateLink(linkId, data){
			return $http.put('/mvmnt-api/link/' + linkId, data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function updateNavigation(data){
			return $http.put('/mvmnt-api/navigation', data)
			.then(function(response){
			return response.data;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function attachRole(data){
			return $http.post('/mvmnt-api/link-attach-role', data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function detachRole(data){
			return $http.post('/mvmnt-api/link-detach-role', data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function deleteLink(linkId, data){
			return $http.delete('/mvmnt-api/link/' + linkId)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
	} 
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('LinkattrService', LinkattrService)
	LinkattrService.$inject = ['$http']
	function LinkattrService($http){
		return {
			getAllLinkattrsByParent: getAllLinkattrsByParent,
			getAllLinkattrsByProperty: getAllLinkattrsByProperty,
			getAllLinkattrs: getAllLinkattrs,
			getLinkattr: getLinkattr,
			addLinkattr: addLinkattr,
			updateLinkattr: updateLinkattr,
			deleteLinkattr: deleteLinkattr
		}
		function getAllLinkattrsByParent(parentId){
			return $http.get('/mvmnt-api/linkattrs-by-parent/' + parentId)
			.then(function(response){
				return response.data;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAllLinkattrsByProperty(property1Name,property1Value){
			return $http.get('/mvmnt-api/all-linkattr-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAllLinkattrs(){
			return $http.get('/mvmnt-api/all-linkattr')
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getLinkattr(linkattrId){
			return $http.get('/mvmnt-api/linkattr/' + linkattrId)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function addLinkattr(data){
			return $http.post('/mvmnt-api/linkattr', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function updateLinkattr(linkattrId, data){
			return $http.put('/mvmnt-api/linkattr/' + linkattrId, data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function deleteLinkattr(linkattrId){
			return $http.delete('/mvmnt-api/linkattr/' + linkattrId)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('LogService', LogService)
	LogService.$inject = ['$http']
	function LogService($http){
		var service = {
			addLog:addLog
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/

		function addLog(data){
            return $http.post('/mvmnt-api/write-log', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('MessageService', MessageService)
	MessageService.$inject = ['$http']
	function MessageService($http){
		return {
			getAllMessagesByParent: getAllMessagesByParent,
			getAllMessagesByProperty: getAllMessagesByProperty,
			getAllMessages: getAllMessages,
			getSearchMessages: getSearchMessages,
			getMessage: getMessage,
			addMessage: addMessage,
			updateMessage: updateMessage,
			deleteMessage: deleteMessage
		}
		function getAllMessagesByParent(parentId,parentType){
			return $http.get('/mvmnt-api/messages-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
				
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllMessagesByProperty(propertyName,propertyValue){
			return $http.get('/mvmnt-api/all-messages-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllMessages(){
			return $http.get('/mvmnt-api/all-messages')
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getSearchMessages(){
			return $http.get('/mvmnt-api/search-messages/' + parentId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getMessage(addressId){
			return $http.get('/mvmnt-api/message/' + addressId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function addMessage(data){
			return $http.post('/mvmnt-api/message', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function updateMessage(messageId, data){
			return $http.put('/mvmnt-api/message/' + addressId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function deleteMessage(addressId){
			return $http.delete('/mvmnt-api/message/' + addressId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
	} 
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('MilestoneService', MilestoneService)
	MilestoneService.$inject = ['$http']
	function MilestoneService($http){
		return {
			getAllMilestonesByParent: getAllMilestonesByParent,
			getAllMilestonesByProperty: getAllMilestonesByProperty,
			getAllMilestones: getAllMilestones,
			getSearchMilestones: getSearchMilestones,
			getMilestone: getMilestone,
			addMilestone: addMilestone,
			updateMilestone: updateMilestone,
			deleteMilestone: deleteMilestone,
			logMilestone: logMilestone,
			unlogMilestone: unlogMilestone
		}
		function getAllMilestonesByParent(parentId,parentType){
			return $http.get('/mvmnt-api/milestones-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllMilestonesByProperty(property1Name,property1Value){
			return $http.get('/mvmnt-api/all-milestones-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllMilestones(){
			return $http.get('/mvmnt-api/all-milestones')
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getSearchMilestones(){
			return $http.get('/mvmnt-api/search-milestones/' + parentId)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getMilestone(milestoneId){
			return $http.get('/mvmnt-api/milestone/' + milestoneId)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function addMilestone(data){
			return $http.post('/mvmnt-api/milestone', data)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function updateMilestone(milestoneId, data){
			return $http.put('/mvmnt-api/milestone/' + milestoneId, data)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function deleteMilestone(milestoneId, data){
			return $http.delete('/mvmnt-api/milestone/' + milestoneId)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function logMilestone(data){
			return $http.post('/mvmnt-api/log-milestone', data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function unlogMilestone(data){
			return $http.post('/mvmnt-api/unlog-milestone', data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
	} 
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('NoticeService', NoticeService)
	NoticeService.$inject = ['$http']
	function NoticeService($http){
		return {
			getAllNoticesByParent: getAllNoticesByParent,
			getAllNoticesByProperty: getAllNoticesByProperty,
			getAllNotices: getAllNotices,
			getSearchNotices: getSearchNotices,
			getNotice: getNotice,
			addNotice: addNotice,
			updateNotice: updateNotice,
			deleteNotice: deleteNotice
		}
		function getAllNoticesByParent(parentId,parentType){
			return $http.get('/mvmnt-api/notices-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllNoticesByProperty(property1Name,property1Value){
			return $http.get('/mvmnt-api/all-notices-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllNotices(){
			return $http.get('/mvmnt-api/all-notices')
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getSearchNotices(){
			return $http.get('/mvmnt-api/search-notices/' + parentId)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getNotice(noticeId){
			return $http.get('/mvmnt-api/notice/' + noticeId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function addNotice(data){
			return $http.post('/mvmnt-api/notice', data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function updateNotice(noticeId, data){
			return $http.put('/mvmnt-api/notice/' + noticeId, data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function deleteNotice(noticeId, data){
			return $http.delete('/mvmnt-api/notice/' + noticeId)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
	} 
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('OrderService', OrderService)
	OrderService.$inject = ['$http']
	function OrderService($http){
		var service = {
			getAllOrdersByParent:getAllOrdersByParent,
			getAllOrdersByProperty:getAllOrdersByProperty,
			getOrdersByScope:getOrdersByScope,
			getAllOrders:getAllOrders,
			getOrder:getOrder,
			addOrder:addOrder,
			attachOrderToParent:attachOrderToParent,
			detachOrderFromParent:detachOrderFromParent,
			updateOrder:updateOrder,
			deleteOrder:deleteOrder
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/

		function getAllOrdersByParent(parentId,parentType){
			return $http.get('/mvmnt-api/orders-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllOrdersByProperty(propertyName,propertyValue){
			return $http.get('/mvmnt-api/orders-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getOrdersByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/mvmnt-api/orders-by-scope/' + scopeName + '/' + count + '/' + ((queryParam != 0) ? queryParam : 'any');
			if (queryParam1 != 0) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getOrdersByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllOrders(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/mvmnt-api/all-orders';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getOrder(orderId){
			return $http.get('/mvmnt-api/order/' + orderId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addOrder(data){
			return $http.post('/mvmnt-api/order', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updateOrder(orderId, data){
			return $http.put('/mvmnt-api/order/' + orderId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};


		function attachOrderToParent(data){
			return $http.post('/mvmnt-api/attach-order-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachOrderFromParent(data){
			return $http.post('/mvmnt-api/detach-order-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteOrder(orderId, data){
			return $http.delete('/mvmnt-api/order/' + orderId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('OrderlineService', OrderlineService)
	OrderlineService.$inject = ['$http']
	function OrderlineService($http){
		var service = {
			getAllOrderlinesByParent:getAllOrderlinesByParent,
			getAllOrderlinesByProperty:getAllOrderlinesByProperty,
			getOrderlinesByScope:getOrderlinesByScope,
			getAllOrderlines:getAllOrderlines,
			getOrderline:getOrderline,
			addOrderline:addOrderline,
			attachOrderlineToParent:attachOrderlineToParent,
			detachOrderlineFromParent:detachOrderlineFromParent,
			updateOrderline:updateOrderline,
			deleteOrderline:deleteOrderline
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/

		function getAllOrderlinesByParent(parentId,parentType){
			return $http.get('/mvmnt-api/orderlines-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllOrderlinesByProperty(propertyName,propertyValue){
			return $http.get('/mvmnt-api/orderlines-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getOrderlinesByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/mvmnt-api/orderlines-by-scope/' + scopeName + '/' + count + '/' + ((queryParam != 0) ? queryParam : 'any');
			if (queryParam1 != 0) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getOrderlinesByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllOrderlines(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/mvmnt-api/all-orderlines';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getOrderline(orderlineId){
			return $http.get('/mvmnt-api/orderline/' + orderlineId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addOrderline(data){
			return $http.post('/mvmnt-api/orderline', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updateOrderline(orderlineId, data){
			return $http.put('/mvmnt-api/orderline/' + orderlineId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};


		function attachOrderlineToParent(data){
			return $http.post('/mvmnt-api/attach-orderline-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachOrderlineFromParent(data){
			return $http.post('/mvmnt-api/detach-orderline-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteOrderline(orderlineId, data){
			return $http.delete('/mvmnt-api/orderline/' + orderlineId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('PersonService', PersonService)
	PersonService.$inject = ['$http']
	function PersonService($http){
		return {
			getAllPeopleByParent: getAllPeopleByParent,
			getAllPeopleByProperty: getAllPeopleByProperty,
			getPeopleByScope: getPeopleByScope,
			getAllPeople: getAllPeople,
			getSearchPeople: getSearchPeople,
			getPerson: getPerson,
			addPerson: addPerson,
			updatePerson: updatePerson,
			deletePerson: deletePerson
		}
		function getAllPeopleByParent(parentId,parentType){
			return $http.get('/mvmnt-api/people-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAllPeopleByProperty(property1Name,property1Value){
			return $http.get('/mvmnt-api/all-people-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getPeopleByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/mvmnt-api/people-by-scope/' + scopeName;
			if ((count != undefined) && (count != '')) {
				url = url + '/' + count;
			}
			if ((queryParam != undefined) && (queryParam != '')) {
				url = url + '/' + queryParam;
			}
			if ((queryParam1 != undefined) && (queryParam1 != '')) {
				url = url + '/' + queryParam1;
			}

			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getPeopleByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllPeople(){
			return $http.get('/mvmnt-api/all-people')
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getSearchPeople(){
			return $http.get('/mvmnt-api/search-people/' + parentId)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getPerson(personId){
			return $http.get('/mvmnt-api/person/' + personId)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function addPerson(data){
			return $http.post('/mvmnt-api/person', data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function updatePerson(personId, data){
			return $http.put('/mvmnt-api/person/' + personId, data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function deletePerson(personId, data){
			return $http.delete('/mvmnt-api/person/' + personId)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('PhoneService', PhoneService)
	PhoneService.$inject = ['$http']
	function PhoneService($http){
		return {
			getAllPhonesByParent: getAllPhonesByParent,
			getAllPhonesByProperty: getAllPhonesByProperty,
			getPhone: getPhone,
			addPhone: addPhone,
			updatePhone: updatePhone,
			deletePhone: deletePhone
		}
		function getAllPhonesByParent(parentId,parentType){
			return $http.get('/mvmnt-api/phones-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAllPhonesByProperty(property1Name,property1Value){
			return $http.get('/mvmnt-api/all-phones-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getPhone(phoneId){
			return $http.get('/mvmnt-api/phone/' + phoneId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function addPhone(data){
			return $http.post('/mvmnt-api/phone', data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function updatePhone(phoneId, data){
			return $http.put('/mvmnt-api/phone/' + phoneId, data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function deletePhone(phoneId, data){
			return $http.delete('/mvmnt-api/phone/' + phoneId)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('ProductService', ProductService)
	ProductService.$inject = ['$http']
	function ProductService($http){
		var service = {
			getAllProductsByParent:getAllProductsByParent,
			getAllProductsByProperty:getAllProductsByProperty,
			getProductsByScope:getProductsByScope,
			getAllProducts:getAllProducts,
			getProduct:getProduct,
			addProduct:addProduct,
			attachProductToParent:attachProductToParent,
			detachProductFromParent:detachProductFromParent,
			updateProduct:updateProduct,
			deleteProduct:deleteProduct
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/

		function getAllProductsByParent(parentId,parentType){
			return $http.get('/mvmnt-api/products-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllProductsByProperty(propertyName,propertyValue){
			return $http.get('/mvmnt-api/products-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getProductsByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/mvmnt-api/products-by-scope/' + scopeName + '/' + count + '/' + ((queryParam != 0) ? queryParam : 'any');
			if (queryParam1 != 0) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getProductsByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllProducts(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/mvmnt-api/all-products';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getProduct(productId){
			return $http.get('/mvmnt-api/product/' + productId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addProduct(data){
			return $http.post('/mvmnt-api/product', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updateProduct(productId, data){
			return $http.put('/mvmnt-api/product/' + productId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};


		function attachProductToParent(data){
			return $http.post('/mvmnt-api/attach-product-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachProductFromParent(data){
			return $http.post('/mvmnt-api/detach-product-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteProduct(productId, data){
			return $http.delete('/mvmnt-api/product/' + productId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('PromptService', PromptService)
	PromptService.$inject = ['$http']
	function PromptService($http){
		return {
			getAllPromptsByParent: getAllPromptsByParent,
			getAllPromptsByProperty: getAllPromptsByProperty,
			getAllPrompts: getAllPrompts,
			getSearchPrompts: getSearchPrompts,
			getPrompt: getPrompt,
			addPrompt: addPrompt,
			updatePrompt: updatePrompt,
			deletePrompt: deletePrompt
		}
		function getAllPromptsByParent(parentId,parentType){
			return $http.get('/api/all-prompts-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllPromptsByProperty(property1Name,property1Value){
			return $http.get('/api/all-prompts-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllPrompts(){
			return $http.get('/api/all-prompts')
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getSearchPrompts(){
			return $http.get('/api/search-prompts/' + parentId)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getPrompt(promptId){
			return $http.get('/api/prompt/' + promptId)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function addPrompt(data){
			return $http.post('/api/prompt', data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function updatePrompt(promptId, data){
			return $http.put('/api/prompt/' + promptId, data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function deletePrompt(promptId, data){
			return $http.delete('/api/prompt/' + promptId)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
	} 
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('RegisterService', RegisterService)
	RegisterService.$inject = ['$http']
	function RegisterService($http){
		var service = {
			updateUserRegister:updateUserRegister,
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/
		
		function updateUserRegister(userId, data){
			return $http.put('/mvmnt-api/process-registration/' + userId, data)
			.then(function(response){
				response.data.payload.redirect = response.data.redirect
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
	} 
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('RoleService', RoleService)
	RoleService.$inject = ['$http']
	function RoleService($http){
		return {
			getAllRolesByParent: getAllRolesByParent,
			getGrantRolesByParent: getGrantRolesByParent,
			getAllRolesByProperty: getAllRolesByProperty,
			getAllRoles: getAllRoles,
			getSearchRoles: getSearchRoles,
			getRole: getRole,
			addRole: addRole,
			updateRole: updateRole,
			deleteRole: deleteRole,
			attachRole: attachRole,
			detachRole: detachRole
		}
		function getAllRolesByParent(parentId,parentType){
			return $http.get('/mvmnt-api/roles-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getGrantRolesByParent(parentId,parentType){
			return $http.get('/mvmnt-api/grant-roles-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllRolesByProperty(property1Name,property1Value){
			return $http.get('/mvmnt-api/roles-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllRoles(){
			return $http.get('/mvmnt-api/all-roles-by-auth')
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getSearchRoles(){
			return $http.get('/mvmnt-api/search-roles/' + parentId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getRole(roleId){
			return $http.get('/mvmnt-api/role/' + roleId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function addRole(data){
			return $http.post('/mvmnt-api/role', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function updateRole(roleId, data){
			return $http.put('/mvmnt-api/role/' + roleId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function deleteRole(roleId, data){
			return $http.delete('/mvmnt-api/role/' + roleId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};

		function attachRole(data){
			return $http.post('/mvmnt-api/attach-role-to-parent', data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};

		function detachRole(data){
			return $http.post('/mvmnt-api/detach-role-from-parent', data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
	} 
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('SettingService', SettingService)
	SettingService.$inject = ['$http']
	function SettingService($http){
		var service = {
			getAllSettingOpts:getAllSettingOpts,
			getAllSettings:getAllSettings,
			getSetting:getSetting,
			addSetting:addSetting,
			attachSettingToParent:attachSettingToParent,
			detachSettingFromParent:detachSettingFromParent,
			updateSetting:updateSetting,
			deleteSetting:deleteSetting
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/

        function getAllSettingOpts(){
            return $http.get('/mvmnt-api/all-setting-opts')
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllSettings(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/mvmnt-api/all-settings';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getSetting(settingId){
			return $http.get('/mvmnt-api/setting/' + settingId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addSetting(data){
			return $http.post('/mvmnt-api/setting', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updateSetting(settingId, data){
			return $http.put('/mvmnt-api/setting/' + settingId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};


		function attachSettingToParent(data){
			return $http.post('/mvmnt-api/attach-setting-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachSettingFromParent(data){
			return $http.post('/mvmnt-api/detach-setting-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteSetting(settingId, data){
			return $http.delete('/mvmnt-api/setting/' + settingId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('StateService', StateService)
	StateService.$inject = ['$http']
	function StateService($http){
		return {
			getAllStatesByParent: getAllStatesByParent,
			getMissingStatesByParent: getMissingStatesByParent,
			getAllStatesByProperty: getAllStatesByProperty,
			getAllStates: getAllStates,
			getSearchStates: getSearchStates,
			getState: getState,
			addState: addState,
			updateState: updateState,
			deleteState: deleteState,
			attachState: attachState,
			detachState: detachState
		}
		function getAllStatesByParent(parentId,parentType){
			return $http.get('/mvmnt-api/states-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getMissingStatesByParent(parentId,parentType){
			return $http.get('/mvmnt-api/missing-states-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllStatesByProperty(property1Name,property1Value){
			return $http.get('/mvmnt-api/all-states-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllStates(){
			return $http.get('/mvmnt-api/all-states')
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getSearchStates(){
			return $http.get('/mvmnt-api/search-states/' + parentId)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getState(stateId){
			return $http.get('/mvmnt-api/state/' + stateId)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function addState(data){
			return $http.post('/mvmnt-api/state', data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function updateState(stateId, data){
			return $http.put('/mvmnt-api/state/' + stateId, data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function deleteState(stateId, data){
			return $http.delete('/mvmnt-api/state/' + stateId)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function attachState(data){
			return $http.post('/mvmnt-api/attach-state-to-parent', data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function detachState(data){
			return $http.post('/mvmnt-api/detach-state-from-parent', data)
			.then(function(response){
				
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};

	} 
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('StatusfierService', StatusfierService)
	StatusfierService.$inject = ['$http']
	function StatusfierService($http){
		var service = {
			getAllStatusfiersByParent:getAllStatusfiersByParent,
			getAllStatusfiersByProperty:getAllStatusfiersByProperty,
			getAllStatusfiers:getAllStatusfiers,
			getStatusfier:getStatusfier,
			addStatusfier:addStatusfier,
			attachStatusfierToParent:attachStatusfierToParent,
			detachStatusfierFromParent:detachStatusfierFromParent,
			updateStatusfier:updateStatusfier,
			deleteStatusfier:deleteStatusfier
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/

		function getAllStatusfiersByParent(parentId,parentType){
			return $http.get('/mvmnt-api/statusfiers-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllStatusfiersByProperty(propertyName,propertyValue){
			return $http.get('/mvmnt-api/statusfiers-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllStatusfiers(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/mvmnt-api/all-statusfiers';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getStatusfier(statusfierId){
			return $http.get('/mvmnt-api/statusfier/' + statusfierId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addStatusfier(data){
			return $http.post('/mvmnt-api/statusfier', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updateStatusfier(statusfierId, data){
			return $http.put('/mvmnt-api/statusfier/' + statusfierId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};


		function attachStatusfierToParent(data){
			return $http.post('/mvmnt-api/attach-statusfier-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachStatusfierFromParent(data){
			return $http.post('/mvmnt-api/detach-statusfier-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteStatusfier(statusfierId, data){
			return $http.delete('/mvmnt-api/statusfier/' + statusfierId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('TagService', TagService)
	TagService.$inject = ['$http']
	function TagService($http){
		return {
			getAllTagsByParent: getAllTagsByParent,
			getFirstTagsByTagname: getFirstTagsByTagname,
			getCountTagsByTagname: getCountTagsByTagname,
			getAllTagsByProperty: getAllTagsByProperty,
			getAllTagsByModel: getAllTagsByModel,
			getAllTags: getAllTags,
			getSearchTags: getSearchTags,
			getTag: getTag,
			addTag: addTag,
			updateTag: updateTag,
			deleteTag: deleteTag
		}
		function getAllTagsByParent(parentId,parentType){
			return $http.get('/mvmnt-api/tags-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getFirstTagsByTagname(tagName){
			return $http.get('/mvmnt-api/first-tag-by-tagname/' + tagName )
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getCountTagsByTagname(tagName){
			return $http.get('/mvmnt-api/count-tag-by-tagname/' + tagName )
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllTagsByProperty(propertyName,propertyValue){
			return $http.get('/mvmnt-api/tags-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllTagsByModel(model){
			return $http.get('/mvmnt-api/tags-by-model/' + model)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllTags(){
			return $http.get('/mvmnt-api/all-tags')
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getSearchTags(){
			return $http.get('/mvmnt-api/search-tags/' + parentId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getTag(tagId){
			return $http.get('/mvmnt-api/tag/' + tagId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function addTag(data){
			return $http.post('/mvmnt-api/tag', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function updateTag(tagId, data){
			return $http.put('/mvmnt-api/tag/' + tagId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function deleteTag(tagId){
			return $http.delete('/mvmnt-api/tag/' + tagId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
	} 
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('TaskService', TaskService)
	TaskService.$inject = ['$http']
	function TaskService($http){
		return {
			getAllTasksByParent: getAllTasksByParent,
			getAllTasksByUser: getAllTasksByUser,
			getRecentTasksByUser: getRecentTasksByUser,
			getMyTasks: getMyTasks,
			getMyRecentTasks: getMyRecentTasks,
			getAllTasksByProperty: getAllTasksByProperty,
			getTasksByCategory: getTasksByCategory,
			getAllReceivedContractsTasksSummary: getAllReceivedContractsTasksSummary,
			getAllTasksSummary: getAllTasksSummary,
			getAllTasks: getAllTasks,
			getAllUsersByTaskParent: getAllUsersByTaskParent,
			getTask: getTask,
			addTask: addTask,
			addTasks: addTasks,
			updateTask: updateTask,
			deleteTask: deleteTask
		}
		function getAllTasksByParent(parentId,parentType){
			return $http.get('/mvmnt-api/tasks-by-parent/' + parentId + '/' + parentType)
			.then(function(response){

				if(response.status == 200){
					return response.data.payload;
				} else {
					console.error("ERROR: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function getAllTasksByUser(userId){
			return $http.get('/mvmnt-api/tasks-by-user/' + userId)
			.then(function(response){

				if(response.status == 200){
					return response.data.payload;
				} else {
					console.error("ERROR: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function getRecentTasksByUser(userId){
			return $http.get('/mvmnt-api/recent-tasks-by-user/' + userId)
			.then(function(response){

				if(response.status == 200){
					return response.data.payload;
				} else {
					console.error("ERROR: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function getMyRecentTasks(){
			return $http.get('/mvmnt-api/tasks-my-recent')
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				} else {
					console.error("ERROR: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function getMyTasks(){
			return $http.get('/mvmnt-api/tasks-mine')
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				} else {
					console.error("ERROR: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function getAllTasksByProperty(propertyName,propertyValue){
			return $http.get('/mvmnt-api/all-tasks-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				} else {
					console.error("ERROR: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function getTasksByCategory(categoryId){
			return $http.get('/mvmnt-api/tasks-by-category/' + categoryId )
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				} else {
					console.error("ERROR: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function getAllReceivedContractsTasksSummary(){
			return $http.get('/mvmnt-api/all-received-contract-tasks-summary')
			.then(function(response){

				if(response.status == 200){
					return response.data.payload;
				} else {
					console.error("ERROR: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function getAllTasksSummary(){
			return $http.get('/mvmnt-api/all-tasks-summary')
			.then(function(response){

				if(response.status == 200){
					return response.data.payload;
				} else {
					console.error("ERROR: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function getAllTasks(q){
			return $http.get('/mvmnt-api/all-tasks/' + q)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				} else {
					console.error("ERROR: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function getAllUsersByTaskParent(parentId,parentType){
			return $http.get('/mvmnt-api/all-users-by-task-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				} else {
					console.error("ERROR: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function getTask(taskId){
			return $http.get('/mvmnt-api/task/' + taskId)
			.then(function(response){

				if(response.status == 200){
					return response.data.payload;
				} else {
					console.error("ERROR: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function addTask(data){
			return $http.post('/mvmnt-api/task', data)
			.then(function(response){

				if(response.status == 200){
					return response.data.payload;
				} else {
					console.error("ERROR: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function addTasks(data){
			return $http.post('/mvmnt-api/tasks', data)
			.then(function(response){

				if(response.status == 200){
					return response.data.payload;
				} else {
					console.error("ERROR: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function updateTask(taskId, data){
			return $http.put('/mvmnt-api/task/' + taskId, data)
			.then(function(response){

				if(response.status == 200){
					return response.data.payload;
				} else {
					console.error("ERROR: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteTask(taskId, data){
			return $http.delete('/mvmnt-api/task/' + taskId)
			.then(function(response){

				if(response.status == 200){
					return response.data.payload;
				} else {
					console.error("ERROR: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('TasktmplService', TasktmplService)
	TasktmplService.$inject = ['$http']
	function TasktmplService($http){
		return {
			getAllTasktmplsByParent: getAllTasktmplsByParent,
			getAllTasktmplsByProperty: getAllTasktmplsByProperty,
			getAllTasktmpls: getAllTasktmpls,
			getTasktmpl: getTasktmpl,
			addTasktmpl: addTasktmpl,
			updateTasktmpl: updateTasktmpl,
			deleteTasktmpl: deleteTasktmpl
		}
		function getAllTasktmplsByParent(parentType){
			return $http.get('/mvmnt-api/tasktmpls-by-parent/' + parentType)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllTasktmplsByProperty(property1Name,property1Value){
			return $http.get('/mvmnt-api/all-tasktmpls-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllTasktmpls(q){
			return $http.get('/mvmnt-api/all-tasktmpls/' + q)
			.then(function(response){
				
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getTasktmpl(tasktmplId){
			return $http.get('/mvmnt-api/tasktmpl/' + tasktmplId)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function addTasktmpl(data){
			return $http.post('/mvmnt-api/tasktmpl', data)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function updateTasktmpl(tasktmplId, data){
			return $http.put('/mvmnt-api/tasktmpl/' + tasktmplId, data)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function deleteTasktmpl(tasktmplId, data){
			return $http.delete('/mvmnt-api/tasktmpl/' + tasktmplId)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
	} 
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('TemplateService', TemplateService)
	TemplateService.$inject = ['$http']
	function TemplateService($http){
		var service = {
			getAllTemplatesByParent:getAllTemplatesByParent,
			getAllTemplatesByProperty:getAllTemplatesByProperty,
			getAllTemplatesByModel:getAllTemplatesByModel,
			getTemplatesByScope:getTemplatesByScope,
			getAllTemplates:getAllTemplates,
			getTemplate:getTemplate,
			addTemplate:addTemplate,
			attachTemplateToParent:attachTemplateToParent,
			detachTemplateFromParent:detachTemplateFromParent,
			updateTemplate:updateTemplate,
			deleteTemplate:deleteTemplate
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/

		function getAllTemplatesByParent(parentId,parentType){
			return $http.get('/mvmnt-api/templates-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllTemplatesByProperty(propertyName,propertyValue){
			return $http.get('/mvmnt-api/templates-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllTemplatesByModel(modelCode){
			return $http.get('/mvmnt-api/templates-by-model/' + modelCode)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getTemplatesByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/mvmnt-api/templates-by-scope/' + scopeName + '/' + count + '/' + ((queryParam != 0) ? queryParam : 'any');
			if (queryParam1 != 0) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getTemplatesByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllTemplates(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/mvmnt-api/all-templates';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getTemplate(templateId){
			return $http.get('/mvmnt-api/template/' + templateId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addTemplate(data){
			return $http.post('/mvmnt-api/template', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updateTemplate(templateId, data){
			return $http.put('/mvmnt-api/template/' + templateId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};


		function attachTemplateToParent(data){
			return $http.post('/mvmnt-api/attach-template-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachTemplateFromParent(data){
			return $http.post('/mvmnt-api/detach-template-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteTemplate(templateId, data){
			return $http.delete('/mvmnt-api/template/' + templateId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('TimelineService', TimelineService)
	TimelineService.$inject = ['$http']
	function TimelineService($http){
		return {
			getAllTimelinesByParent: getAllTimelinesByParent,
			getAllTimelinesByProperty: getAllTimelinesByProperty,
			getAllTimelines: getAllTimelines,
			getTimeline: getTimeline,
			addTimeline: addTimeline,
			updateTimeline: updateTimeline,
			deleteTimeline: deleteTimeline
		}
		function getAllTimelinesByParent(parentId,parentType){
			return $http.get('/api/timelines-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllTimelinesByProperty(property1Name,property1Value){
			return $http.get('/api/all-timelines-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllTimelines(q){
			return $http.get('/api/all-timelines/' + q)
			.then(function(response){
				
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getTimeline(timelineId){
			return $http.get('/api/timeline/' + timelineId)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function addTimeline(data){
			return $http.post('/api/timeline', data)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function updateTimeline(timelineId, data){
			return $http.put('/api/timeline/' + timelineId, data)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function deleteTimeline(timelineId, data){
			return $http.delete('/api/timeline/' + timelineId)
			.then(function(response){
				
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR: ", response); 
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
	} 
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('TimesheetService', TimesheetService)
	TimesheetService.$inject = ['$http']
	function TimesheetService($http){
		return {
			getAllTimesheetsByParent: getAllTimesheetsByParent,
			getGroupedTimesheetsByParent: getGroupedTimesheetsByParent,
			getGroupedTimesheetsByUser: getGroupedTimesheetsByUser,
			getAllOpenTimesheetsByParent: getAllOpenTimesheetsByParent,
			getAllOpenTimesheetsByUser: getAllOpenTimesheetsByUser,
			getAllTimesheetsByUser: getAllTimesheetsByUser,
			getAllTimesheetsByProperty: getAllTimesheetsByProperty,
			getAllOpenTimesheetsByProperty: getAllOpenTimesheetsByProperty,
			getAllTimesheets: getAllTimesheets,
			getSearchTimesheets: getSearchTimesheets,
			getTimesheet: getTimesheet,
			addTimesheet: addTimesheet,
			updateTimesheet: updateTimesheet,
			deleteTimesheet: deleteTimesheet
		}
		function getAllTimesheetsByParent(parentId,parentType){
			return $http.get('/mvmnt-api/timesheets-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getGroupedTimesheetsByParent(parentId,parentType,$groupByColumnOne,$groupByColumnTwo){
			$groupByColumnOne = $groupByColumnOne || "";
			$groupByColumnTwo = $groupByColumnTwo || "";
			var url = '/mvmnt-api/grouped-timesheets-by-parent/' + parentId + '/' + parentType;
			if($groupByColumnOne.length > 0){
				url = url + '/' + $groupByColumnOne;
			}
			if($groupByColumnTwo.length > 0){
				url = url + '/' + $groupByColumnTwo;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getGroupedTimesheetsByUser(userId,$groupByColumnOne){
			$groupByColumnOne = $groupByColumnOne || "";
			var url = '/mvmnt-api/grouped-timesheets-by-user/' + userId;
			if($groupByColumnOne.length > 0){
				url = url + '/' + $groupByColumnOne;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllOpenTimesheetsByParent(parentId,parentType){
			return $http.get('/mvmnt-api/open-timesheets-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllOpenTimesheetsByUser(userId){
			return $http.get('/mvmnt-api/open-timesheets-by-user/' + userId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllTimesheetsByUser(userId){
			return $http.get('/mvmnt-api/timesheets-by-user/' + userId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllTimesheetsByProperty(property1Name,property1Value){
			return $http.get('/mvmnt-api/timesheets-by-property/' + property1Name + '/' + property1Value)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllOpenTimesheetsByProperty(property1Name,property1Value){
			return $http.get('/mvmnt-api/open-timesheets-by-property/' + property1Name + '/' + property1Value)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getAllTimesheets(){
			return $http.get('/mvmnt-api/all-timesheets')
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getSearchTimesheets(){
			return $http.get('/mvmnt-api/search-timesheets/' + parentId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function getTimesheet(timesheetId){
			return $http.get('/mvmnt-api/timesheet/' + timesheetId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function addTimesheet(data){
			return $http.post('/mvmnt-api/timesheet', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function updateTimesheet(timesheetId, data){
			return $http.put('/mvmnt-api/timesheet/' + timesheetId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
		function deleteTimesheet(timesheetId, data){
			return $http.delete('/mvmnt-api/timesheet/' + timesheetId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err); 
				throw err;
			});

		};
		
	} 
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('TypifierService', TypifierService)
	TypifierService.$inject = ['$http']
	function TypifierService($http){
		var service = {
			getAllTypifiersByParent:getAllTypifiersByParent,
			getAllTypifiersByProperty:getAllTypifiersByProperty,
			getAllTypifiers:getAllTypifiers,
			getTypifier:getTypifier,
			addTypifier:addTypifier,
			attachTypifierToParent:attachTypifierToParent,
			detachTypifierFromParent:detachTypifierFromParent,
			updateTypifier:updateTypifier,
			deleteTypifier:deleteTypifier
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/

		function getAllTypifiersByParent(parentId,parentType){
			return $http.get('/mvmnt-api/typifiers-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllTypifiersByProperty(propertyName,propertyValue){
			return $http.get('/mvmnt-api/typifiers-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllTypifiers(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/mvmnt-api/all-typifiers';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getTypifier(typifierId){
			return $http.get('/mvmnt-api/typifier/' + typifierId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addTypifier(data){
			return $http.post('/mvmnt-api/typifier', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updateTypifier(typifierId, data){
			return $http.put('/mvmnt-api/typifier/' + typifierId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};


		function attachTypifierToParent(data){
			return $http.post('/mvmnt-mvmnt-api/attach-typifier-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachTypifierFromParent(data){
			return $http.post('/mvmnt-mvmnt-api/detach-typifier-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteTypifier(typifierId, data){
			return $http.delete('/mvmnt-api/typifier/' + typifierId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

//# sourceMappingURL=_mvmntservices.js.map
